import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators, ValueChangeEvent} from "@angular/forms";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {NgxUiLoaderService} from "ngx-ui-loader";
import Swal from "sweetalert2";
import {SwalComponent} from "@sweetalert2/ngx-sweetalert2";

@Component({
  selector: 'app-page-contact-three',
  templateUrl: './page-contact-three.component.html',
  styleUrls: ['./page-contact-three.component.css']
})


/**
 * Page Contact-Three Component
 */
export class PageContactThreeComponent implements OnInit {

    @ViewChild('closeButton') closeButton: ElementRef<HTMLElement>;

    @ViewChild('confirmHotel')
    public readonly confirmHotel!: SwalComponent;

      // Set Topbar Option
  Menuoption = 'center';
  Settingicon = true

  hotelForm: FormGroup
    hotelFormSend:boolean = false

  constructor(private modalService: NgbModal, private fb: FormBuilder, private http: HttpClient,
              private loader: NgxUiLoaderService) { }

  ngOnInit(): void {
      this.initForm()
  }

  mapView(content) {
    this.modalService.open(content, { windowClass: 'dark-modal', size: 'lg', centered: true })
  }

  initForm() {
    this.hotelForm = this.fb.group({
        name: ['', Validators.required],
        birthDate: ['', Validators.required],
        document: ['', Validators.required],
        phone: ['', Validators.required],
        email: ['',Validators.required],
        ladieName: [],
        ladieBirthDate: [''],
        ladieDocument: [''],
        ladiePhone: [''],
        ladieEmail: [''],
        zipCode: ['',Validators.required],
        address: ['',Validators.required],
        guests: ['',Validators.required],
        bedType: ['',Validators.required],
        options:['',Validators.required],

    })
  }

  sendRequest() {
      this.hotelFormSend=true
      if(this.hotelForm.valid) {
          this.loader.start()
          const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json')
          return this.http.post('https://api.amalshriners.org.br/site/lasa/sesc', this.hotelForm.value, {headers: httpHeaders}).subscribe((res) => {
              this.loader.stop()
              this.showMessage("Solicitação enviada com sucesso")
              console.log(res)
              this.closeModal()
              this.hotelFormSend=false
              this.hotelForm.reset()
          }, err => {
                this.loader.stop()
                this.showMessage("Erro ao enviar solicitação",'error')
          })
      }else{
          this.showMessage("Solicitação enviada com sucesso",'error')
      }

  }

    showMessage(msg = '', type = 'success') {
      console.log("message")
        const toast: any = Swal.mixin({
            toast: true,
            position: 'top',
            showConfirmButton: false,
            timer: 3000,
            customClass: { container: 'toast' },
        });
        toast.fire({
            icon: type,
            title: msg,
            padding: '10px 20px',
        });
    }

    closeModal(){
        let el: HTMLElement = this.closeButton.nativeElement;
        el.click();

        this.confirmHotel.fire()
    }

}
